import React, { useState } from "react";
import OtpInput from "react-otp-input";
import PinInput from "react-pin-input";
import "./style.scss";
import { toast } from "react-toastify";

export default function OTPComponent({submitOTP}) {
  const [otp, setOtp] = useState("");

  const handleSubmit =()=>{
    if(otp.length<4){
      toast.warn("Please enter valid otp", { position: "top-center" });
      return;
    }
    submitOTP(otp)
  }

  return (
   
    <div className="otp-container">
      <p className="text-xl font-semibold text-center">PLEASE ENTER OTP</p>
      <PinInput
        length={4}
        initialValue=""
        secret={false}
        inputMode="numeric"
        autoSelect={true}
        onChange={(value) => setOtp(value)}
        autoFocus
        // onComplete={(value) => console.log("OTP:", value)}
        inputStyle={{
          borderColor: "#d9d9d9",
          borderRadius: "10px",
          width: "48px",
          height: "48px",
          margin: "0 8px",
          fontSize: "18px",
          fontWeight: "600",
          color: "#000",
          backgroundColor: "#fff",
        }}
        inputFocusStyle={{
          borderColor: "#1677ff",
          boxShadow: "0 0 0 2px rgba(22,119,255,0.2)",
        }}
        containerStyle={{
          justifyContent: "center",
        }}
      />

      <div className="button-container">
        <button className="otp-submit-button" onClick={handleSubmit}>
          submit
        </button>
      </div>
    </div>
  );
}
